const env = {
  ga4: process.env.REACT_APP_GA4_ID,
  ads: process.env.REACT_APP_GOOGLE_ADS_ID,
  adsLabel: process.env.REACT_APP_GOOGLE_ADS_LEAD_LABEL,
  pixel: process.env.REACT_APP_META_PIXEL_ID,
};

const loadScript = (src) => {
  const s = document.createElement("script");
  s.async = true;
  s.src = src;
  document.head.appendChild(s);
};

let started = false;
export function initAnalytics() {
  if (started) return;
  started = true;
  window.dataLayer = window.dataLayer || [];
  const gtagId = env.ga4 || env.ads;
  if (gtagId) {
    window.gtag = function gtag() { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    if (env.ga4) window.gtag("config", env.ga4, { send_page_view: false });
    if (env.ads) window.gtag("config", env.ads);
  }
  if (env.pixel) {
    const f = (window.fbq = function fbq() { f.callMethod ? f.callMethod.apply(f, arguments) : f.queue.push(arguments); });
    f.push = f; f.loaded = true; f.version = "2.0"; f.queue = [];
    window.fbq("init", env.pixel);
  }
  const load = () => {
    if (gtagId) loadScript(`https://www.googletagmanager.com/gtag/js?id=${gtagId}`);
    if (env.pixel) loadScript("https://connect.facebook.net/en_US/fbevents.js");
  };
  if (document.readyState === "complete") setTimeout(load, 1500);
  else window.addEventListener("load", () => setTimeout(load, 1500), { once: true });
}

export function track(event, params = {}) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
  if (window.gtag) window.gtag("event", event, params);
  if (window.fbq) window.fbq("trackCustom", event, params);
}

export function trackPageView(path) {
  if (window.gtag && env.ga4) window.gtag("event", "page_view", { page_path: path, page_location: window.location.href, page_title: document.title });
  if (window.fbq) window.fbq("track", "PageView");
}

export function trackLeadConversion() {
  track("thank_you_view");
  if (window.gtag && env.ads && env.adsLabel) window.gtag("event", "conversion", { send_to: `${env.ads}/${env.adsLabel}` });
  if (window.fbq) window.fbq("track", "Lead");
}

export function bindClickTracking() {
  const onClick = (e) => {
    const a = e.target.closest && e.target.closest("a");
    if (!a) return;
    const href = a.getAttribute("href") || "";
    if (href.startsWith("tel:")) track("click_to_call", { link_location: a.dataset.loc || "" });
    else if (href.startsWith("mailto:")) track("click_email", { link_location: a.dataset.loc || "" });
    if (a.dataset.cta) track("cta_click", { cta_id: a.dataset.cta, link_url: href });
  };
  document.addEventListener("click", onClick);
  return () => document.removeEventListener("click", onClick);
}
